import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import Chip, { ChipProps } from '@/components/molecules/chip/chip';
import Link from '@/components/utilities/link/link';
import styles from './filter-chip-list.module.scss';

export interface FilterChip extends ChipProps {
  id: string;
}

export interface FilterChipListProps<T extends FilterChip> {
  /** The class name to apply */
  className?: string;
  /** The label to show for the clear all button */
  clearLabel?: string;
  /** An array of the filter chips to show */
  items: T[];
  /** An event that is triggered on removing all filter chips */
  onClickRemoveAll?: () => void;
  /** An event that is triggered on removing a filter chip */
  onClickRemoveChip?: (item: T) => void;
}

const FilterChipList = <T extends FilterChip>({
  className,
  clearLabel,
  items = [],
  onClickRemoveAll,
  onClickRemoveChip,
}: FilterChipListProps<T>) => {
  if (items.length === 0) return;

  return (
    <div className={classNames(styles.component, className)}>
      {items.map(item => (
        <Chip
          key={item.id}
          label={item.label}
          onClickClose={() => onClickRemoveChip?.(item)}
        />
      ))}

      {items.length > 0 && onClickRemoveAll && (
        <Link onClick={() => onClickRemoveAll?.()}>
          <Typography className={styles.link} tagStyle="bodySmall">
            {clearLabel}
          </Typography>
        </Link>
      )}
    </div>
  );
};

FilterChipList.displayName = 'FilterChipList';

export default FilterChipList;
